import * as React from 'react'
import { createFileRoute, Link } from '@tanstack/react-router'

import { validateUserAddPermission } from "@/lib/api/auth"
import { Button } from "@/components/ui/button"
import {
  Credenza,
  CredenzaBody,
  CredenzaClose,
  CredenzaContent,
  CredenzaDescription,
  CredenzaFooter,
  CredenzaHeader,
  CredenzaTitle,
} from '@/components/ui/credenza'
import SMSForm from '@/components/forms/sms-form'
import { Icons } from '@/components/icons'

export const Route = createFileRoute('/_home/message-templates/sms/add')({
  component: AddSMSPage,
})

export default function AddSMSPage() {
  const [showAddEmailTemplatedEmailModal, setShowAddEmailTemplatedEmailModal] =
    React.useState<boolean>(false)
  return (
    <main>
      <div>
        <Button
          onClick={() => {
            {
              if (!validateUserAddPermission()) return
              setShowAddEmailTemplatedEmailModal(true)
            }
            setShowAddEmailTemplatedEmailModal(true)
          }}
        >
          <Icons.add className="size-4" />
          Add SMS Templated Messages
        </Button>
      </div>
      <Credenza
        open={showAddEmailTemplatedEmailModal}
        onOpenChange={setShowAddEmailTemplatedEmailModal}
      >
        <CredenzaContent className="flex w-full max-w-[750px] justify-center">
          <CredenzaBody className="mx-auto w-full max-w-6xl px-4">
            <SMSForm
              setShowAddEmailTemplatedEmailModal={
                setShowAddEmailTemplatedEmailModal
              }
            />
          </CredenzaBody>
        </CredenzaContent>
      </Credenza>
    </main>
  )
}
